import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AutoCloseableClass;
function AutoCloseable() {
  if (AutoCloseableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AutoCloseable');
    AutoCloseableClass = $;
  }
  return AutoCloseableClass;
}
//region block: exports
export {
  AutoCloseable as AutoCloseable1l5p57f9lp7kv,
};
//endregion

//# sourceMappingURL=AutoCloseableJs.mjs.map
